export enum Pages {
  Home = 'home',
  EndUserVerification = 'endUserVerification',
  ClientPortalChats = 'clientPortalChats',
  SecureDataSharing = 'secureDataSharing',
  TechnicianVerification = 'technicianVerification',
  SMSMessaging = 'smsMessaging',
  WhatsAppMessaging = 'whatsAppMessaging',
  QuickTicket = 'quickTicket',
  MSTeamsChats = 'MSTeamsChats',
}

export enum VerificationPages {
  VerificationItem = 'verificationItem',
  VerificationData = 'verificationData',
}

export enum ActionsPages {
  SelectActions = 'SelectActions',
  CreateSecureData = 'CreateSecureData',
  SendSecureData = 'SendSecureData',
}
